/** Default checklist for grant opportunities with no specific template match. */
export const GENERIC_GRANT_TASKS = [
  {
    id: 1,
    name: "Confirm eligibility",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Review grant criteria with client", completed: false },
      { id: "1-2", name: "Confirm company meets eligibility requirements", completed: false },
      { id: "1-3", name: "Get client sign-off to proceed", completed: false },
    ],
  },
  {
    id: 2,
    name: "Gather application materials",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Collect required documents from client", completed: false },
      { id: "2-2", name: "Draft or review application responses", completed: false },
      { id: "2-3", name: "Internal QA review before submission", completed: false },
    ],
  },
  {
    id: 3,
    name: "Submit application",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Submit via portal or email", completed: false },
      { id: "3-2", name: "Confirm submission receipt with client", completed: false },
    ],
  },
  {
    id: 4,
    name: "Follow up until decision",
    completed: false,
    subtasks: [
      { id: "4-1", name: "Track status and deadlines", completed: false },
      { id: "4-2", name: "Respond to any funder requests", completed: false },
    ],
  },
];
